module.exports = __webpack_public_path__ + "img/ditki.4805a1ca.png";